import { HTTP } from '@/shared/http';
import router from '../../router';
import cookie from 'vue-cookies';


export default {
  state: {
    // login data
    userId: null,
    idToken: null,
    error: null,
    authenticated: false,
    user: null,
    currentDisplayUser: null
  },

  mutations: {
    SET_AUTHENTICATED(state, value) {
      state.authenticated = value;
    },

    SET_USER(state, value) {
      state.user = value;
      // if( state.user )
      //   this._vm.$i18n.locale = state.user.locale;
      const storageValue = value ? JSON.stringify(value) : null;
      if (storageValue) {
        localStorage.setItem('user', storageValue);
      } else {
        localStorage.removeItem('user');
      }
    },

    SET_USER_ID(state, value) {
      state.userId = value;
      if (value) {
        localStorage.setItem('userId', value);
      } else {
        localStorage.removeItem('userId');
      }
    },

    SET_SESSION_COOKIE(state, value) {
      state.sessionCookie = value;
      if (value) {
        localStorage.setItem('sessionCookie', value);
      } else {
        localStorage.removeItem('sessionCookie');
      }
    },

    // login mutations
    authUser(state, userData) {
      state.idToken = userData.token;
      state.userId = userData.userId;
      state.error = null;
      console.log('Login user with id:' + state.userId);
    },

    error(state, error) {
      state.error = error;
    },

    clearUser(state) {
      state.idToken = null;
      state.userId = null;
      state.error = null;
      console.log('User was logged out');
    },
    SET_IMAGES_FOR_USER(state, image) {
      state.user.images.push(image);
    },
    SET_LOGO_FOR_USER(state, image) {
      state.user.logos.push(image);
    },
    REPLACE_IMAGES_WITH_EXISTING_IMAGES(state, images) {
      state.user.images = images;
    },
    REPLACE_LOGOS_WITH_EXISTING_LOGOS(state, logos) {
      state.user.logos = logos;
    },
    SET_PLAN_FOR_USER(state, planValue) {
      state.user.plan = planValue;
    },
    SET_CURRENT_DISPLAY_USER(state, user) {
      state.currentDisplayUser = user;
    }
  },

  actions: {
    reset({ commit }, email) {
      console.log('commit password reset for email:' + email);

      return HTTP.post('/api/reset', { email: email })
        .then((response) => {
          if (!response.data) commit('setInfo', 'Email not found!');
          return response;
        })
        .catch((error) => console.log(error));
    },

    register({ commit }, authData) {
      console.log('commit registration with credentials:' + authData);
      return HTTP.post('/register', authData).then((response) => {
        if (response.data.error) {
          console.log('register failed with response:', response);
          commit('error', response.data.code);
        }
        return response;
      });
    },

    signin({ commit, dispatch }, authData) {
      console.log('commit signin with email:' + authData.email);
      // let responseObj = null;
      return HTTP.get('/sanctum/csrf-cookie')
        .then(() => {
          return HTTP.post('/login', authData);
        })
        .then((response) => {
          //responseObj = response;
          console.log('login response:', response);
          if (response.data.error || response.data.errors) {
            console.log('login failed with response:', response);
            commit('error', response.data.code);
            return response;
          } else {
            // set a wordpress cookie
            console.log('login successful -> set WP cooky');
            document.cookie = 'kulibri=sso;path=/;domain=kulibri.com';
            return dispatch('getLoggedInUser');
          }
        });
      // .then(() =>
      // responseObj);
      // .then(() => responseObj)
      // .catch((error) => {
      //   console.log(`error signIn ${error}`, error);
      //   return error;
      // });
      // return response;
    },

    getLoggedInUser({ commit }, i18n) {
      return HTTP.get('/api/user')
        .then((response) => {
          // const sessionCookie = cookie.get(process.env.VUE_APP_COOKIE_NAME);
          // if (sessionCookie) {
          //   commit('SET_SESSION_COOKIE', sessionCookie);
          // } else {
          //   commit('SET_SESSION_COOKIE', null);
          // }
          console.log('getLoggedInUser ok:', response);

          const user = response.data;
          commit('SET_AUTHENTICATED', true);
          commit('SET_USER', user);
          commit('SET_USER_ID', user.id);
          if (i18n) {
            i18n.locale = user.locale;
          }

          return response;
        })
        .catch((error) => {
          console.log('getLoggedInUser failed:', error.response);
          commit('SET_AUTHENTICATED', false);
          commit('SET_USER', null);
          commit('SET_SESSION_COOKIE', null);
          commit('SET_USER_ID', null);
        });
    },

    tryAutoLogin({ commit, dispatch }, i18n = null) {
      console.log('tryAutoLogin');

      const userId = localStorage.getItem('userId');
      const user = localStorage.getItem('user');

      // if no user and userId -> user is not logged in

      if (userId === 'social') {
        return dispatch('getLoggedInUser', i18n);
      }

      if (user == null) {
        console.log('no local user found');
        return;
      }
      console.log('local user found');

      console.log('AutoLogin is going to login user with id:', userId);

      commit('SET_AUTHENTICATED', true);
      commit('SET_USER_ID', userId);
      commit('SET_USER', JSON.parse(user));

      const sessionCookie = cookie.get(process.env.VUE_APP_COOKIE_NAME);
      if (!sessionCookie) {
        // commit('SET_AUTHENTICATED', false);
        // commit('SET_USER', null);
        // commit('SET_USER_ID', null);
        // commit('SET_SESSION_COOKIE', null);

        // try to get the current user. If the request return an error, the user will be redirected to signin
        return dispatch('getLoggedInUser');
        // return;
      }
    },

    logout({ commit /*, dispatch*/ }, redirect = true) {
      console.log('Store Login Module logout');
      HTTP.post('/logout')
        // .then(() => {
        //   return dispatch('getLoggedInUser');
        // })
        .then(() => {
          // as replacement for getLoggedInUser
          console.log('laravel logout complted');
          commit('SET_AUTHENTICATED', false);
          commit('SET_USER', null);
          commit('SET_SESSION_COOKIE', null);
          commit('SET_USER_ID', null);

          commit('clearUser');
          localStorage.removeItem('token');
          localStorage.removeItem('userId');
          localStorage.removeItem('expirationDate');
          localStorage.removeItem('polls');
          localStorage.removeItem('userParticipants');
          //document.cookie = 'kulibri=sso;path=/;domain=kulibri.com';

          document.cookie =
            'kulibri=;path=/;domain=kulibri.com;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
          if (redirect) {
            const homeUrl = process.env.VUE_APP_PUBLIC_HOME;
            console.log('logout redirect - ', homeUrl);
            window.location.href = homeUrl;
          } else {
            // if no redirect required refresh the csrf-cookie
            HTTP.get('/sanctum/csrf-cookie');
          }
        })
        .catch((error) => {
          console.log(`logout error ${error}`);
          router.push('/signin');
        });
    },

    async updateUser({ commit }, newUser) {
      console.log('Store Login Update user', newUser);
      return HTTP.put('/api/user', newUser)
        .then((response) => {
          console.log('HTTP Post /api/user response:', response.data);
          commit('SET_USER', newUser);
        })
        .catch(() => {});
    },
    updatePassword(_, newUser) {
      console.log('Store Login Update user password', newUser);
      return HTTP.put('/api/user/password', newUser)
        .then((response) => {
          console.log('HTTP Post /api/user response:', response.data);
          return response;
        })
        .catch((error) => {
          console.log({ error });
        });
    },
    addImageInUserImages({ commit }, image) {
      commit('SET_IMAGES_FOR_USER', image);
    },
    replaceImagesToUserImagesObject({ commit }, images) {
      commit('REPLACE_IMAGES_WITH_EXISTING_IMAGES', images);
    },
    addLogoInUserLogos({ commit }, image) {
      commit('SET_LOGO_FOR_USER', image);
    },
    replaceLogosToUserImagesObject({ commit }, logos) {
      commit('REPLACE_LOGOS_WITH_EXISTING_LOGOS', logos);
    },
    replaceExistingUserDetails({ commit }, updateUserDetails) {
      commit('SET_USER', updateUserDetails);
    },
    updatePlanForUser({commit}, planValue) {
      commit('SET_PLAN_FOR_USER', planValue);
    },
    updateCurrentDisplayUser({ commit }, user) {
      commit('SET_CURRENT_DISPLAY_USER', user);
    },
    deleteUser(_, email) {
      // console.log('Store Login Update user', newUser);
      return HTTP.post('/api/user/delete', {email: email})
        .then((response) => {
          // console.log('HTTP Post /api/user response:', response.data);
          return response.data;
        })
        .catch(() => {});
    },
  },

  getters: {
    isAuthenticated(state) {
      return state.authenticated;
    },
    getCurrentDisplayUser(state) {
      return state.currentDisplayUser;
    }
  },
};
